import { match as integer } from "../../../src/params/integer.js";

export const matchers = { integer };